import { media } from '../';

export default {
  fontPrimary: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSecondary:
    '"Raleway", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  fontWeightRegular: 400,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  defaultLineHeight: 1.6,
  defaultFontSize: 16,
  lineHeight1: 1.2,
  lineHeight12: 1.29,
  lineHeight13: 1.33,
  lineHeight14: 1.37,
  lineHeight15: 1.39,
  lineHeight16: 1.43,
  lineHeight17: 1.5,
  lineHeight18: 1.56,
  lineHeightDefault: 1.6,
  letterSpacingXSmall: '0.02rem',
  letterSpacingSmall: '0.025rem',
  letterSpacingMedium: '0.03rem',
  letterSpacingLarge: '0.0313rem',
  letterSpacingXLarge: '0.04rem',
};

// Converts px to rem
export function rem(size: number) {
  const remSize = size / 16;
  return `${remSize}rem`;
}

export function headingStyles(
  desktopFontSize: number,
  desktopLetterSpacing: string,
  desktopLineHeight: number,
  margin: string,
  mobileFontSize: number,
  mobileLetterSpacing: string,
  mobileLineHeight: number,
) {
  return `
		font-size: ${rem(desktopFontSize)};
		letter-spacing: ${desktopLetterSpacing};
		line-height: ${desktopLineHeight};
		margin: ${margin};
		@media ${media.small} {
			font-size: ${rem(mobileFontSize)};
			letter-spacing: ${mobileLetterSpacing};
			line-height: ${mobileLineHeight};
		}
	`;
}
